export const GET_BENEFICERS = 'GET_BENEFICERS';
export const LOADING_BENEFICERS = 'LOADING_BENEFICERS';
export const SAVE_LOADER_BENEFICERS = 'SAVE_LOADER_BENEFICERS';
